



























































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { LearningRequest as ILearningRequest } from "@/api/models/learning-request";
import { LearningRequestEdit as ILearningRequestEdit } from "@/api/models/learning-request-edit";
import { ContractorNew as IContractor } from "@/api/models/contractor-new";
import { User as IUser } from "@/api/models/user";
import api from "@/getinfo-api";
import SearchUser from "@/components/user/SearchUser.vue";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { Employee as IEmployee } from "@/api/models/employee";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import Modal from "@/components/form/Modal.vue";
import { uniqBy } from "lodash";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import { isAllowEditDates } from "@/plugins/modules-detect";
import CField from "@/components/form/CField.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { ContractorsListClass } from "@/classes/list/ContractorsListClass";
import { getCurrentCompanyId, getCurrentEmployee } from "@/plugins/roles";
import { IUserFilter, usersFilter } from "@/utils/filter-listeners";
import { nextSequence } from "@/utils/generate-helper";
import DocumentNumberInput from "@/components/form/DocumentNumberInput.vue";

@Component({
  components: {
    DocumentNumberInput,
    CSingleSelect,
    CField,
    CustomDatepicker,
    CustomButton,
    Modal,
    SearchUser
  }
})
export default class OrderFormEdit extends Vue {
  @Prop() order?: ILearningRequest;
  companyId!: string;
  clientType!: string | undefined;
  clientId!: string | undefined;
  resourceType!: string;
  resourceId!: string | undefined;
  price!: number;
  priceForOne!: number;
  users!: Array<IUser>;
  responsibleId?: string;
  number!: string;
  documentsManagerList!: Array<IEmployee>;
  learningEntity!: string | undefined;
  isSaving: boolean = false;
  contractorList?: ContractorsListClass | never = this.isEmployee
    ? new ContractorsListClass(
        {
          limit: 999,
          type: this.clientType,
          companyId: this.selectCompanyId
        },
        this.order?.contractor?.id
      )
    : undefined;
  isCanEditPrice: boolean = false;
  userRegisteredAtMin!: Date | undefined;
  userRegisteredAtMax!: Date | undefined;
  searchListenerByEmail!: string;

  data() {
    return {
      number: undefined,
      companyId: undefined,
      clientType: undefined,
      clientId: undefined,
      resourceType: undefined,
      resourceId: undefined,
      price: undefined,
      users: undefined,
      responsibleId: undefined,
      documentsManagerList: [],
      learningEntity: undefined,
      searchListenerByEmail: "",
      userRegisteredAtMin: undefined,
      userRegisteredAtMax: undefined,
      priceForOne: undefined
    };
  }

  get filteredUsers() {
    const params: IUserFilter = {
      email: this.searchListenerByEmail,
      fullName: this.searchListenerByEmail,
      registeredAtMin: this.userRegisteredAtMin,
      registeredAtMax: this.userRegisteredAtMax
    };
    return usersFilter(this.users, params);
  }

  clearFilter() {
    this.userRegisteredAtMin = undefined;
    this.userRegisteredAtMax = undefined;
    this.searchListenerByEmail = "";
  }

  get selectCompanyId() {
    return getCurrentCompanyId();
  }

  get isEmployee() {
    return !!getCurrentEmployee();
  }

  get isAllowEditDates() {
    return isAllowEditDates();
  }

  getOnlyCurrentContractors() {
    return this.clientType === "juridical"
      ? this.$store.state.user.user.juridicalContractor
      : this.$store.state.user.user.physicalContractor;
  }

  selectResponsibleForOnlyContractor(contractor: IContractor) {
    this.responsibleId =
      contractor?.responsible?.id ?? this.order?.responsibleId ?? undefined;
  }

  deleteLearningRequest() {
    if (this.order) {
      api.LearningRequestApi._delete(this.order.id)
        .then(() => {
          this.$store.dispatch("successToast", {
            message: this.$tc(this.$translate.SuccessfullyDeleted)
          });
          this.$router.push({ name: "orders" });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  @Watch("clientType")
  checkClientType() {
    //@ts-ignore
    this.contractorList.params.type = this.clientType
      ? this.clientType
      : undefined;
    this.contractorList!.params.offset = 0;
    this.contractorList!.listItems = [];
    this.contractorList!.list();
  }

  get formattedResourceType() {
    let type = "";
    if (this.resourceType === "course") {
      type = this.$tc(this.$translate.Course);
    }
    if (this.resourceType === "webinar") {
      type = this.$tc(this.$translate.Webinar);
    }
    if (this.resourceType === "video") {
      type = this.$tc(this.$translate.Record);
    }
    return type;
  }

  saveOrder() {
    this.isSaving = true;
    let params: ILearningRequestEdit = {
      number: this.number,
      contractorId: this.clientId,
      responsibleId: this.responsibleId,
      price: this.$converter.setPrice(this.price),
      userIds: this.users.map(el => el.id)
    };
    if (this.order) {
      api.LearningRequestApi.edit(this.order.id, params)
        .then(async (res: { data: ILearningRequest }) => {
          await nextSequence();
          await this.$router.push({
            name: "orderItem",
            params: { orderId: res.data.id }
          });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.isSaving = false;
        });
    }
  }
  selectUser(item: IUser) {
    this.users.push(item);
    this.users = uniqBy(this.users, "id");
  }

  deleteUsers(item: IUser) {
    this.users = this.users.filter((element: IUser) => {
      return element !== item;
    });
  }

  get addedUsersIds() {
    return this.users.map(el => el.id);
  }

  @Watch("order")
  getOrderInfo() {
    if (this.order) {
      this.number = this.order.number;
      this.companyId = this.order.companyId;
      this.order.contractor && this.order.contractor.id
        ? (this.clientId = this.order.contractor.id)
        : null;
      this.clientType = this.order.contractor?.type;
      this.resourceId = this.order.resourceId;
      this.resourceType = this.order.resourceType;
      this.price = this.$converter.getPrice(this.order.price);
      this.users = this.order.users;
      this.responsibleId = this.order.responsibleId;
      this.learningEntity = this.order.resourceTitle;
      this.priceForOne = this.$converter.getPrice(
        this.order.price / this.order.users.length
      );
      let documents_manager_params: EmployeeListParams = {
        id: this.companyId,
        roles: ["learning_request_manager"],
        limit: 200
      };

      if (this.isEmployee) {
        employee(documents_manager_params)
          .then((res: { data: IEmployeesList2 }) => {
            this.documentsManagerList = res.data.employees;
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          );
      }
    }
  }

  get formattedPrice() {
    if (this.addedUsersIds && this.resourceId && !this.isCanEditPrice) {
      this.price = +(this.addedUsersIds.length * this.priceForOne).toFixed(0);
    }
    return this.price;
  }

  set formattedPrice(value) {
    this.price = value;
  }

  mounted() {
    this.getOrderInfo();
  }
}
